import { useCallback } from "react";
import {
  ENV_NAMES,
  ENV_URL_PARTS,
} from "src/utils/newRelic/newRelicErrorReport";
import { getOrgStructureNRAgent } from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/newRelicAgent";
import reportErrorToNewRelic from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/reportErrorToNewRelic";
import { LogStatusProps, NewRelicLogLevel } from "./useLogStatus.models";

const getEnvironment = () => {
  const url = window.location.origin;
  if (url.includes(ENV_URL_PARTS.DEV)) return ENV_NAMES.DEV;
  if (url.includes(ENV_URL_PARTS.STAGING)) return ENV_NAMES.STAGING;
  return ENV_NAMES.PROD;
};

export const useLogStatus = () => {
  const logStatus = useCallback(
    ({
      type,
      message,
      statusDetails,
      errorObject,
    }: LogStatusProps & { errorObject?: Error }) => {
      const agent = getOrgStructureNRAgent();
      if (!agent || type === NewRelicLogLevel.SUCCESS) return;

      const env = getEnvironment();
      const mess = `[${env}] ${message}`;
      const isApiError = statusDetails?.source === "API";
      const attributes = { env, level: type, ...(statusDetails || {}) };

      if (type === NewRelicLogLevel.ERROR && !isApiError) {
        reportErrorToNewRelic(errorObject || new Error(mess), message);
      } else if (agent.log) {
        agent.log(mess, { customAttributes: attributes });
      }
    },
    []
  );

  return logStatus;
};
